// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1174add6","113":"4a6ab685","191":"e150df63","402":"d38efea7","418":"3aded773","451":"7a7fbc4b","453":"1cd34b31","525":"ceda5318","605":"b3943b2c","729":"36607949","739":"a4ea14d2","827":"42fcff16","915":"a5e5d638","980":"8e4982b1","996":"0bd03c3b"}[chunkId] + ".chunk.js";
};